import React from 'react';
import localeText from '../../../locale';

const ConfimeaCTA = () => {
  return (
    <section className="confimea-cta-section hidden md:block">
      <div className="confimea-container">
        <div className="confimea-cta-inner">
          <div className="confimea-cta-title">{localeText("ctaTitle")}</div>
          <div className="confimea-cta-text">
            {localeText("ctaText")}
          </div>
          <a href="#form" className="confimea-btn confimea-btn-white">
            {localeText("ctaButton")}
            <svg className="confimea-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ConfimeaCTA;
